import { Pipe, PipeTransform } from '@angular/core';
import { Silo, LocationSilo } from '@next/core-lib/cart';

import { FormatLabelPipe } from './format-label.pipe';

@Pipe({ name: 'formatSiloTitle', standalone: true })
export class FormatSiloTitlePipe implements PipeTransform {
  constructor(private readonly formatLabelPipe: FormatLabelPipe) {}

  public transform(value: Silo | LocationSilo): string {
    if (value === null) {
      return '';
    }

    return this.formatLabelPipe.transform({
      name: value.name ?? '',
      value: value.siloNumber,
    });
  }
}
